import {
  getBookingStartingPoint,
  getCompanyType,
  salonTracking,
  setBookingStartingPoint,
  trackMpEvent,
  trackMpMetaEvent,
  trackPage,
  trackPageCio,
} from '@/helpers';
import { track } from '@/helpers/tracking';
import { PLACE_IMPRESSION, placeService } from '@/services';
import { Place } from '@/types/state/shared';
import type { ButtonID } from '@bokadirekt/tracking-schema/marketplace';
import moment from 'moment';

export const trackPlacePage = (place: Place) => {
  trackPage();
  trackMpEvent(
    'screen_shown',
    {
      screen_name: 'company_details',
      company_id: place.id,
      company_type: getCompanyType(place),
    },
    false,
  );
  trackPageCio('company_details', {
    merchant_id: place.id,
    merchant_name: place.about.name,
  });
  trackMpMetaEvent('ViewContent', {
    content_ids: [place.id],
    content_name: place.about.name,
    contents: [{ id: place.id, content_name: place.about.name }],
  });
  salonTracking(place);
  if (!getBookingStartingPoint()) {
    setBookingStartingPoint('company_details');
  }
};

/** `Button Clicked` for a contact button or link on the place page. Web sent no legacy event for these. */
export const trackPlaceButtonClicked = (place: Pick<Place, 'id' | 'about'>, buttonId: ButtonID) =>
  track('Button Clicked', {
    button_id: buttonId,
    screen_name: 'place_details',
    place_id: String(place.id),
    place_name: place.about.name,
  });

export const savePlaceVisit = (place: Place) => {
  try {
    const mpPlaceVisits = JSON.parse(localStorage.getItem('mpPlaceVisits')) || {};
    const placeVisits = mpPlaceVisits[place.id] || [];
    const totalVisits = placeVisits.length;
    const unix = moment().unix();

    if (totalVisits === 5) {
      placeVisits.shift();
    }

    placeVisits.push(unix);

    mpPlaceVisits[place.id] = placeVisits;
    localStorage.setItem('mpPlaceVisits', JSON.stringify(mpPlaceVisits));
    localStorage.setItem(
      'mpLastVisited',
      JSON.stringify({
        id: place.id,
        about: place.about,
        contact: place.contact,
        rating: place.reviews?.stats || null,
      }),
    );

    placeService.storePlaceImpressions([place.id], PLACE_IMPRESSION.PLACE_IMPRESSION);
  } catch (e) {
    console.error('Error setting place visit', e);
  }
};
